import {
  DELETE_POLICE_STATEMENT_SUCCESS,
  DELETE_POLICE_STATEMENT_FAILURE,
  DELETE_POLICE_STATEMENT_REQUEST,
} from "../constants/MyM";
import { deleteApi } from "../../utils/apiCall";
import { apiToastError, apiToastSuccess } from "../../utils/MyMUtils";

const deletePoliceStatementSuccess = (data) => {
  return {
    type: DELETE_POLICE_STATEMENT_SUCCESS,
    payload: data,
  };
};

const deletePoliceStatementFailure = (data) => {
  return {
    type: DELETE_POLICE_STATEMENT_FAILURE,
    payload: data,
  };
};

export const deletePoliceStatementRequest = () => ({
  type: DELETE_POLICE_STATEMENT_REQUEST,
});

export const deletePoliceStatement = (id, facilityId) => {
  return async (dispatch, getState) => {
    dispatch(deletePoliceStatementRequest());
    const { error, result } = await deleteApi(`/police_statement/${id}`, {
      facility_id: facilityId
    });
    if (!error) {
      apiToastSuccess(result);
      return dispatch(deletePoliceStatementSuccess(result));
    } else {
      apiToastError(result);
      return dispatch(deletePoliceStatementFailure(result));
    }
  };
};